import {FormContainer} from './contact-recognition.styles.jsx';

const ContactRecognition = () => {
    return(
        <FormContainer>
            <i>
            Thank you for your message!
            We will get back to you as soon as possible.
            </i>
        </FormContainer>
    )
}

export default ContactRecognition;